export default {
  GeneralError: {
    Title:
      'It looks like something went wrong — maybe we should try again?',
    Button: {
      Return: 'Return to the previous page',
      Contact: 'Contact us',
    },
    Or: 'or',
  },
  CantInsure: {
    Title:
      'We cannot offer you an online quote',
    HelpText:
      'Contact our consultant to find out how we can help you. Call 22 501 35 01.',
  },
  NotFoundError: {
    Title: 'Oops, page not found',
    Text: 'You will be redirected to a working page shortly:',
  },
};
